<template>
	<div class="register-view">
		<div class="register-main">
			<div class="register-box">
				<div class="title-section">
					<h1 class="register-title">创建账号</h1>
					<p class="register-subtitle">欢迎加入我们，一起来叨叨</p>
				</div>
				
				<div class="loading-tip" v-if="loading">
					<i class="el-icon-loading"></i>
					<span>加载中...</span>
				</div>
				
				<div class="disabled-tip" v-else-if="!allowRegister">
					<i class="el-icon-warning"></i>
					<span>当前系统已关闭新用户注册功能</span>
				</div>
				
				<el-form :model="registerForm" status-icon :rules="rules" ref="registerForm" class="form" v-else>
					<el-form-item prop="nickName" class="form-item">
						<label class="form-label">用户昵称</label>
						<div class="input-wrapper">
							<i class="input-icon el-icon-user"></i>
							<el-input v-model="registerForm.nickName" type="text" autocomplete="off" placeholder="起一个好听的名字" maxlength="20" class="wechat-input">
							</el-input>
						</div>
					</el-form-item>
					<el-form-item prop="userName" class="form-item">
						<label class="form-label">手机号 / 账号</label>
						<div class="input-wrapper">
							<i class="input-icon el-icon-phone"></i>
							<el-input v-model="registerForm.userName" type="text" autocomplete="off" placeholder="输入手机号作为登录凭证" maxlength="11" class="wechat-input">
							</el-input>
						</div>
					</el-form-item>
					<el-form-item prop="password" class="form-item">
						<label class="form-label">设置登录密码</label>
						<div class="input-wrapper">
							<i class="input-icon el-icon-lock"></i>
							<el-input :type="showPassword ? 'text' : 'password'" v-model="registerForm.password" autocomplete="off" placeholder="至少8位字符" maxlength="20" class="wechat-input">
							</el-input>
							<span class="password-toggle" @click="togglePassword">
								<i :class="showPassword ? 'el-icon-eye' : 'el-icon-eye-off'"></i>
							</span>
						</div>
					</el-form-item>
					<el-form-item prop="confirmPassword" class="form-item">
						<label class="form-label">确认密码</label>
						<div class="input-wrapper">
							<i class="input-icon el-icon-shield"></i>
							<el-input :type="showConfirmPassword ? 'text' : 'password'" v-model="registerForm.confirmPassword" autocomplete="off" placeholder="请再次输入密码" maxlength="20" class="wechat-input">
							</el-input>
							<span class="password-toggle" @click="toggleConfirmPassword">
								<i :class="showConfirmPassword ? 'el-icon-eye' : 'el-icon-eye-off'"></i>
							</span>
						</div>
					</el-form-item>
					<el-form-item prop="invitationCode" class="form-item" v-if="needInvitationCode">
						<label class="form-label">邀请码</label>
						<div class="input-wrapper">
							<i class="input-icon el-icon-gift"></i>
							<el-input v-model="registerForm.invitationCode" type="text" autocomplete="off" placeholder="输入邀请码" maxlength="32" class="wechat-input">
							</el-input>
						</div>
					</el-form-item>
					<el-form-item class="protocol-item">
						<el-checkbox v-model="agreeProtocol" class="protocol-checkbox">
							我已阅读并同意 <a href="#" class="link">《服务协议》</a> 和 <a href="#" class="link">《隐私政策》</a>
						</el-checkbox>
					</el-form-item>
					<el-button class="submit-btn" type="primary" @click="submitForm('registerForm')">立即注册</el-button>
				</el-form>
				
				<div class="login-link" v-if="!loading && allowRegister">
					已有账号？<a href="/#/login" class="login-btn">立即登录</a>
				</div>
			</div>
			
			<div class="register-copyright">{{ copyright }}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "register",
	data() {
		var checkUserName = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入账号'));
			}
			if (!/^\d+$/.test(value)) {
				return callback(new Error('账号必须为纯数字'));
			}
			if (value.length < 5) {
				return callback(new Error('账号最少5位数字'));
			}
			if (value.length > 11) {
				return callback(new Error('账号最多11位数字'));
			}
			callback();
		};
		var checkNickName = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入昵称'));
			}
			if (value.length < 2) {
				return callback(new Error('昵称最少2个字符'));
			}
			if (value.length > 20) {
				return callback(new Error('昵称最多20个字符'));
			}
			callback();
		};
		var checkPassword = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入密码'));
			}
			if (value.length < 6) {
				callback(new Error('密码最少6位'));
			}
			callback();
		};
		var checkConfirmPassword = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请确认密码'));
			}
			if (value !== this.registerForm.password) {
				callback(new Error('两次输入的密码不一致'));
			}
			callback();
		};
		return {
			registerForm: {
				userName: '',
				nickName: '',
				password: '',
				confirmPassword: '',
				invitationCode: ''
			},
			needInvitationCode: false,
			allowRegister: false,
			loading: true,
			agreeProtocol: false,
			showPassword: false,
			showConfirmPassword: false,
			copyright: '© 2026 叨叨|内部技术研究测试专用',
			rules: {
				userName: [{
					validator: checkUserName,
					trigger: 'blur'
				}],
				nickName: [{
					validator: checkNickName,
					trigger: 'blur'
				}],
				password: [{
					validator: checkPassword,
					trigger: 'blur'
				}],
				confirmPassword: [{
					validator: checkConfirmPassword,
					trigger: 'blur'
				}]
			}
		};
	},
	mounted() {
		this.loadSystemConfig();
	},
	methods: {
		togglePassword() {
			this.showPassword = !this.showPassword;
		},
		toggleConfirmPassword() {
			this.showConfirmPassword = !this.showConfirmPassword;
		},
		loadSystemConfig() {
			this.$http({
				url: "/admin/system/config/list",
				method: 'get'
			}).then((response) => {
				if (response) {
					const configMap = {};
					response.forEach(item => {
						const key = item.configKey || item.key;
						const value = item.configValue || item.value;
						configMap[key] = value;
					});
					this.allowRegister = configMap['register_enabled'] === 'true';
					this.needInvitationCode = configMap['invitation_required'] === 'true';
				}
			}).catch(() => {
				this.allowRegister = false;
				this.needInvitationCode = false;
			}).finally(() => {
				this.loading = false;
			});
		},
		submitForm(formName) {
			if (!this.agreeProtocol) {
				this.$message.error('请先阅读并同意服务协议和隐私政策');
				return;
			}
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.$http({
						url: "/register",
						method: 'post',
						data: this.registerForm
					})
						.then((data) => {
							this.$message.success("注册成功");
							this.$router.push("/");
						})
				}
			});
		}
	}
}
</script>

<style scoped lang="scss">
.register-view {
	width: 100%;
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #f9fafb;
}

.register-main {
	width: 100%;
	max-width: 500px;
	padding: 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.register-box {
	width: 100%;
	background: #ffffff;
	border-radius: 20px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
	padding: 32px;
	box-sizing: border-box;
}

.title-section {
	margin-bottom: 30px;
	
	.register-title {
		font-size: 24px;
		font-weight: 700;
		color: #1f2937;
		margin: 0 0 8px 0;
	}
	
	.register-subtitle {
		font-size: 14px;
		color: #6b7280;
		margin: 0;
	}
}

.loading-tip, .disabled-tip {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 60px 20px;
	color: #888;
	
	i {
		font-size: 48px;
		margin-bottom: 16px;
		color: #07c160;
	}
	
	span {
		font-size: 16px;
	}
}

.disabled-tip {
	i {
		font-size: 48px;
		margin-bottom: 16px;
		color: #f59e0b;
	}
}

.form {
	.form-item {
		margin-bottom: 0;
		
		& + .form-item {
			margin-top: 16px;
		}
	}
	
	.form-label {
		display: block;
		font-size: 14px;
		font-weight: 500;
		color: #374151;
		margin-bottom: 8px;
		padding-left: 4px;
	}
	
	.input-wrapper {
		position: relative;
		
		.input-icon {
			position: absolute;
			left: 12px;
			top: 50%;
			transform: translateY(-50%);
			color: #9ca3af;
			font-size: 16px;
			transition: color 0.3s;
		}
		
		.password-toggle {
			position: absolute;
			right: 12px;
			top: 50%;
			transform: translateY(-50%);
			cursor: pointer;
			color: #9ca3af;
			font-size: 16px;
			transition: color 0.3s;
			
			&:hover {
				color: #07c160;
			}
		}
	}
	
	.wechat-input {
		width: 100%;
		
		.el-input__inner {
			width: 100%;
			height: 40px;
			line-height: 40px;
			border: 1px solid #e5e7eb;
			border-radius: 8px;
			padding: 0 12px 0 40px;
			font-size: 14px;
			color: #1f2937;
			background: #f9fafb;
			transition: all 0.3s;
			
			&:focus {
				border-color: #07c160;
				background: #ffffff;
				box-shadow: 0 0 0 3px rgba(7, 193, 96, 0.1);
			}
			
			&::placeholder {
				color: #9ca3af;
				font-size: 14px;
			}
		}
	}
	
	.protocol-item {
		padding: 12px 0;
		margin-bottom: 0;
		
		.protocol-checkbox {
			.el-checkbox__label {
				font-size: 13px;
				color: #6b7280;
				
				.link {
					color: #07c160;
					
					&:hover {
						text-decoration: underline;
					}
				}
			}
		}
	}
	
	.submit-btn {
		width: 100%;
		height: 40px;
		border-radius: 8px;
		background: #07c160;
		color: #fff;
		font-size: 16px;
		font-weight: 600;
		border: none;
		margin-top: 12px;
		box-shadow: 0 4px 12px rgba(7, 193, 96, 0.3);
		transition: all 0.3s;
		
		&:hover {
			background: #06ae56;
			box-shadow: 0 4px 16px rgba(7, 193, 96, 0.4);
		}
		
		&:active {
			transform: scale(0.98);
		}
	}
}

.login-link {
	text-align: center;
	margin-top: 24px;
	font-size: 14px;
	color: #6b7280;
	
	.login-btn {
		color: #07c160;
		text-decoration: none;
		font-weight: 500;
		
		&:hover {
			text-decoration: underline;
		}
	}
}

.register-copyright {
	text-align: center;
	font-size: 12px;
	color: #9ca3af;
	margin-top: 40px;
}

@media screen and (max-width: 768px) {
	.register-box {
		padding: 30px 20px;
		border-radius: 16px;
	}
	
	.title-section {
		margin-bottom: 30px;
		
		.register-title {
			font-size: 22px;
		}
	}
	
	.form {
		.wechat-input {
			.el-input__inner {
				height: 42px;
				line-height: 42px;
				font-size: 14px;
			}
		}
		
		.submit-btn {
			height: 42px;
			font-size: 15px;
			margin-top: 14px;
		}
	}
	
	.login-link {
		margin-top: 28px;
	}
	
	.register-copyright {
		margin-top: 30px;
		font-size: 11px;
	}
}
</style>